import { render, staticRenderFns } from "./detalis.vue?vue&type=template&id=4414f47a&scoped=true&"
import script from "./detalis.vue?vue&type=script&lang=js&"
export * from "./detalis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4414f47a",
  null
  
)

export default component.exports